export const toPaylocityJob = (jobNumber) => {
  const value = String(jobNumber ?? '').trim();
  if (!/^\d{7}$/.test(value)) throw new Error('Enter a seven-digit job number.');
  return `P${value.slice(2)}00`;
};

const allocationHours = (value) => {
  if (value == null || String(value).trim() === '') return null;
  const days = Number(value);
  return Number.isFinite(days) && days >= 0 ? days * 8 : null;
};

export const buildTimeComparison = (project, records, paylocityJob) => {
  const rows = new Map([
    ['MECHANICAL ENGINEERING', { department: 'MECHANICAL ENGINEERING', allocated: allocationHours(project.MechanicalDuration ?? project.mechanicalDuration) }],
    ['ELECTRICAL ENGINEERING', { department: 'ELECTRICAL ENGINEERING', allocated: allocationHours(project.ElectricalDuration ?? project.electricalDuration) }],
  ]);
  rows.forEach(row => Object.assign(row, { regular: 0, ot1: 0, ot2: 0, unpaid: 0, hasTime: false }));
  if (!Array.isArray(records)) throw new Error('Unexpected Paylocity response: expected a list of time records.');
  records.forEach(record => {
    if (String(record.jobs ?? '').trim().toUpperCase() !== paylocityJob) return;
    const department = String(record.work_center_name || 'Not Defined').trim().replace(/\s+/g, ' ').toUpperCase();
    const row = rows.get(department) || { department, allocated: null, regular: 0, ot1: 0, ot2: 0, unpaid: 0, hasTime: false };
    [['regular', 'regular_duration'], ['ot1', 'ot1_duration'], ['ot2', 'ot2_duration'], ['unpaid', 'unpaid_duration']].forEach(([key, field]) => {
      const hours = record[field] == null ? 0 : Number(record[field]);
      if (!Number.isFinite(hours)) throw new Error(`Invalid ${field} for ${department}.`);
      row[key] += hours;
    });
    row.hasTime = true;
    rows.set(department, row);
  });
  return [...rows.values()].map(row => {
    const actual = row.regular + row.ot1 + row.ot2;
    return { ...row, actual, variance: row.allocated == null || !row.hasTime ? null : actual - row.allocated };
  });
};

export const getControlsHours = project => allocationHours(project.ControlsDuration ?? project.controlsDuration);
